import {type AppConfig, __NAME__} from './types'

export const config: AppConfig = window[__NAME__]
